export default {
  "王小川": {
    "name": "王小川",
    "company": "搜狗",
    "position": "创始人 & CEO",
    "sponsor": 1,
    "pic": "user-wxc.jpg"
  },
  "傅盛": {
    "name": "傅 盛",
    "company": "猎豹移动",
    "position": "CEO",
    "sponsor": 1,
    "pic": "user-fs.jpg"
  },
  "周航": {
    "name": "周 航",
    "company": "顺为资本",
    "position": "投资合伙人",
    "sponsor": 1,
    "pic": "user-zh.jpg"
  },
  "李志飞": {
    "name": "李志飞",
    "company": "出门问问",
    "position": "创始人 & CEO",
    "sponsor": 1,
    "pic": "user-lzf.jpg"
  },
  "张鹏": {
    "name": "张 鹏",
    "company": "极客公园",
    "position": "创始人 & 总裁",
    "sponsor": 1,
    "pic": "user-zp.jpg"
  },
  "黎万强": {
    "name": "黎万强",
    "company": "小米",
    "position": "联合创始人",
    "pic": "user-lwq.jpg"
  },
  "周鸿祎": {
    "name": "周鸿祎",
    "company": "奇虎360",
    "position": "董事长",
    "pic": "user-zhy.jpg"
  },
  "刘宗孺": {
    "name": "刘宗孺",
    "company": "BroadLink",
    "position": "创始人 & CEO",
    "pic": "user-lzr.jpg"
  },
  "罗敏": {
    "name": "罗 敏",
    "company": "趣店集团",
    "position": "创始人 & CEO",
    "pic": "user-lm.jpg"
  },
  "余凯": {
    "name": "余 凯",
    "company": "地平线",
    "position": "创始人 & CEO",
    "pic": "user-yk.jpg"
  },
  "陈大年": {
    "name": "陈大年",
    "company": "Wifi万能钥匙",
    "position": "创始人",
    "pic": "user-cdn.jpg"
  },
  "姬十三": {
    "name": "姬十三",
    "company": "果壳、在行、分答",
    "position": "创始人",
    "pic": "user-jss.jpg"
  },
  "黄汪": {
    "name": "黄 汪",
    "company": "华米科技",
    "position": "创始人 & CEO",
    "pic": "user-hw.jpg"
  },
  "沈晖": {
    "name": "沈 晖",
    "company": "威马汽车",
    "position": "创始人 & CEO",
    "pic": "user-sh.jpg"
  },
  "周源": {
    "name": "周 源",
    "company": "知乎",
    "position": "创始人 & CEO",
    "pic": "user-zy.jpg"
  },
  "胡玮炜": {
    "name": "胡玮炜",
    "company": "Mobike",
    "position": "创始人 & 总裁",
    "pic": "user-hww.jpg"
  },
  "张志东": {
    "name": "张志东",
    "company": "腾讯",
    "position": "主要创办人、前CTO",
    "pic": "user-zzd.jpg"
  },
  "曾德钧": {
    "name": "曾德钧",
    "company": "猫王收音机",
    "position": "创始人 & CEO",
    "pic": "user-zdj.jpg"
  },
  "李宇": {
    "name": "李 宇",
    "company": "和缓医疗",
    "position": "董事长 & CEO",
    "pic": "user-ly.jpg"
  },
  "罗小渠": {
    "name": "罗小渠",
    "company": "杉数科技",
    "position": "联合创始人 & CEO",
    "pic": "user-lxq.jpg"
  },
  "何帆": {
    "name": "何 帆",
    "company": "回收宝",
    "position": "创始人 & CEO",
    "pic": "user-hf.jpg"
  },
  "陈磊华": {
    "name": "陈磊华",
    "company": "Coremail",
    "position": "创始人",
    "pic": "user-clh.jpg"
  },
  "薄满辉": {
    "name": "薄满辉",
    "company": "航旅纵横",
    "position": "创始人",
    "pic": "user-bmh.jpg"
  },
  "王佳梁": {
    "name": "王佳梁",
    "company": "触宝",
    "position": "CEO",
    "pic": "user-wjl.jpg"
  },
  "王兵": {
    "name": "王 兵",
    "company": "北京爱佑慈善基金会",
    "position": "创始人",
    "pic": "user-wb.jpg"
  },
  "邬宁": {
    "name": "邬 宁",
    "company": "FIIL",
    "position": "CEO",
    "pic": "user-wn.jpg"
  },
  "黄晓杰": {
    "name": "黄晓杰",
    "company": "暴风魔镜",
    "position": "CEO",
    "pic": "user-hxj.jpg"
  },
  "王智民": {
    "name": "王智民",
    "company": "宝岛眼镜",
    "position": "创始人",
    "pic": "user-wzm.jpg"
  },
  "翟学魂": {
    "name": "翟学魂",
    "company": "G7",
    "position": "创始人 & CEO",
    "pic": "user-zxh.jpg"
  },
  "宋晨枫": {
    "name": "宋晨枫",
    "company": "小鱼在家",
    "position": "创始人 & CEO",
    "pic": "user-scf.jpg"
  },
  "杨洋": {
    "name": "杨 洋",
    "company": "iPIN",
    "position": "创始人 & CEO",
    "pic": "user-yy.jpg"
  },
  "吴甘沙": {
    "name": "吴甘沙",
    "company": "驭势科技",
    "position": "联合创始人 & CEO",
    "pic": "user-wgs.jpg"
  },
  "何小鹏": {
    "name": "何小鹏",
    "company": "小鹏汽车",
    "position": "董事长",
    "pic": "user-hxp.jpg"
  },
  "齐俊元": {
    "name": "齐俊元",
    "company": "Teambition",
    "position": "创始人 & CEO",
    "pic": "user-qjy.jpg"
  },
  "宋少鹏": {
    "name": "宋少鹏",
    "company": "Sugr米唐科技",
    "position": "创始人 & CEO",
    "pic": "user-ssp.jpg"
  },
  "顾嘉唯": {
    "name": "顾嘉唯",
    "company": "物灵科技",
    "position": "创始人 & CEO",
    "pic": "user-gjw.jpg"
  },
  "赖奕龙": {
    "name": "赖奕龙",
    "company": "荔枝FM",
    "position": "创始人 & CEO",
    "pic": "user-lyl.jpg"
  },
  "米雯娟": {
    "name": "米雯娟",
    "company": "VIPKID",
    "position": "创始人 & CEO",
    "pic": "user-mwj.jpg"
  },
  "朱继志": {
    "name": "朱继志",
    "company": "眼擎科技",
    "position": "创始人 & CEO",
    "pic": "user-zjz.jpg"
  },
  "沈鹏": {
    "name": "沈 鹏",
    "company": "水滴公司",
    "position": "创始人 & CEO",
    "pic": "user-sp.jpg"
  },
  "李斌": {
    "name": "李 斌",
    "company": "蔚来",
    "position": "创始人 & 董事长",
    "pic": "user-lb.jpg"
  },
  "张宏江": {
    "name": "张宏江",
    "company": "源码资本",
    "position": "投资合伙人",
    "pic": "user-zhj.jpg"
  },
  "李泽湘": {
    "name": "李泽湘",
    "company": "松山湖国际机器人产业基地",
    "position": "董事长",
    "pic": "user-lzx.jpg"
  },
  "董熠": {
    "name": "董 熠",
    "company": "LifeSmart 云起",
    "position": "创始人 & CEO",
    "pic": "user-dy.jpg"
  },
  "李学凌": {
    "name": "李学凌",
    "company": "欢聚时代（YY.inc)",
    "position": "联合创始人、董事长 & CEO",
    "pic": "user-lxl.jpg"
  },
  "张智武": {
    "name": "张智武",
    "company": "北科天绘",
    "position": "联合创始人 & CEO",
    "pic": "user-zzw.jpg"
  },
  "戴雷": {
    "name": "戴 雷",
    "company": "拜腾 BYTON",
    "position": "联合创始人 & 总裁",
    "pic": "user-dl.jpg"
  },
  "张凯磊": {
    "name": "张凯磊",
    "company": "学霸君",
    "position": "创始人 & CEO",
    "pic": "user-zkl.jpg"
  },
  "张一鸣": {
    "name": "张一鸣",
    "company": "今日头条",
    "position": "创始人 & CEO"
  },
  "张涛": {
    "name": "张涛",
    "company": "大众点评",
    "position": "创始人"
  },
  "徐昕泉": {
    "name": "徐昕泉",
    "company": "LeREE",
    "position": "创始人 & CEO"
  },
  "曹毅": {
    "name": "曹毅",
    "company": "源码资本",
    "position": "创始合伙人"
  },
  "陶喆": {
    "name": "陶喆",
    "company": "　",
    "position": "著名音乐人",
  },
  "张向东": {
    "name": "张向东",
    "company": "700Bike",
    "position": "联合创始人"
  },
  "陈磊": {
    "name": "陈磊",
    "company": "网心科技",
    "position": "CEO、迅雷Co-CEO"
  },
  "冯鑫": {
    "name": "冯鑫",
    "company": "暴风集团",
    "position": "创始人、董事长 & CEO"
  },
  "刘作虎": {
    "name": "刘作虎",
    "company": "一加手机",
    "position": "创始人 & CEO"
  }
}



// WEBPACK FOOTER //
// ./src/mock/members.js